module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "manager"
  }, [(_vm.loaded) ? _c('div', [_c('div', [_c('panels')], 1), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('item-list')], 1), _vm._v(" "), _c('div', {
    staticClass: "filters"
  }, [_c('filters', {
    key: "filter-module",
    attrs: {
      "collapsable": true
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0777ec97","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Manager.vue
// module id = 538
// module chunks = 1